var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.293 13.793a1 1 0 1 1 1.414 1.414L5.414 20.5H9a1 1 0 1 1 0 2H3q-.085-.001-.166-.016-.015-.001-.031-.005l-.035-.007-.061-.016a1 1 0 0 1-.257-.121 1 1 0 0 1-.33-.36l-.02-.042a1 1 0 0 1-.057-.141A1.003 1.003 0 0 1 2 21.5v-6a1 1 0 1 1 2 0v3.586zM21 2.5q.084 0 .165.015l.026.004.01.002.03.006.06.016a1 1 0 0 1 .141.057l.042.02A1 1 0 0 1 22 3.5v6a1 1 0 1 1-2 0V5.914l-5.293 5.293a1 1 0 1 1-1.414-1.414L18.586 4.5H15a1 1 0 1 1 0-2z"
  })));
};
export default Svg24;